import { memo } from "react";
import { ViewTableCell } from "@design-system/ViewTable/ViewTableCell";
import { CellContext } from "@tanstack/react-table";
import type { ViewTableFeatures } from "@design-system/ViewTable/core/table";
import { format, parseISO } from "date-fns";
import { fullDateFullYearFormat } from "@common/helpers/date";
import { BankReconciliationRow } from "../bankReconciliationViewConfig";

export const DateCell = memo(
    ({
        getValue,
    }: CellContext<
        ViewTableFeatures,
        BankReconciliationRow,
        string | null | undefined
    >) => {
        const dateString = getValue();
        const date = dateString ? parseISO(dateString) : null;

        return (
            <ViewTableCell>
                {date ? format(date, fullDateFullYearFormat) : "-"}
            </ViewTableCell>
        );
    },
);
